/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useContext, useEffect, useState } from "react";
import { Label } from "components/Form";
import { Col, Row } from "components/Grid";
import { FieldArray, Formik, Field } from "formik";
import Icon from "components/Icon";
import Colors from "constants/Colors";
import { GlobalAuthContext, GlobalLoaderContext } from 'store/context';
import { FitinsurAPI, MessageCenter } from 'utils';
import { ActionContainer, InlineLabel, Line, CheckBoxColumn, ColIcon, TooltipCard, TooltipText, TooltipBox } from "./styles";
import { ModalConfirmDelete } from 'components/index';
import ComboBox from 'components/Form/ComboBox3';
import { faPen } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Checkbox from 'components/Form/CheckBox';
import { FileIcon, defaultStyles } from 'react-file-icon';
import InputField from 'components/Form/InputField';

const fitinsur = new FitinsurAPI();


const ListDetail = ({
  hasDelete,
  listDocuments,
  document,
  idOperation,
  columns,
  isClient,
  nameArray,
  selectedFolder,
  options,
  handleSelectDocument,
  selectedDocs,
  selectAllDocs,
  iconTooltips,
  onHistoryClick,
  history,
  expired
}) => {
  const authContext = useContext(GlobalAuthContext);
  const loading = useContext(GlobalLoaderContext);
  const mc = new MessageCenter();
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [changeDocumentType, setChangeDocumentType] = useState(false);
  const [currentDocument, setCurrentDocument] = useState({});

  const [oldValue, setOldValue] = useState(0);
  const [testOld, setTestOld] = useState({})
  const [newIdDocument, setNewIdDocument] = useState();

  fitinsur.setAuthToken(authContext.token);

  function handleRmvAttach(idOperation, idDocument) {
    loading.start();

    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestWordingDelAttach(idOperation, idDocument)
      .then(data => data.json())
      .then(resp => {
        if (resp.ret_code !== 200) {
          mc.error(resp.ret_msg_details);
          loading.stop();
          return;
        } else {
          const filterQueryString = `?${jsonToQueryString({ search: '', idOperation })}`;

          listDocuments(filterQueryString);
        }
      }).catch(err => {
        mc.error("An error happened, please try again: " + err);
        loading.stop();
      });
  };

  const renderFlowClient = () => {
    if (nameArray === 'supportDocuments') return (
      <TooltipCard>
        <TooltipText>
          <Icon
            disabled={!hasDelete}
            onClick={() => hasDelete && handleRmvAttach(idOperation, document.idDocument)}
            name="trash"
            style={!hasDelete ? opacity : null}
          />
        </TooltipText>
        <TooltipBox>
          {iconTooltips[596]}
        </TooltipBox>
      </TooltipCard>
    )
  }

  const fieldRenderOptions = function (answers = []) {
    let result = []

    if (nameArray === 'claimsDocuments') {
      answers = options.claims;
    } else {
      answers = options.support;
    }

    answers.forEach(option => {

      let behavior = {}
      try {
        behavior = JSON.parse(option.ANSWER_BEHAVIOR)
      } catch (e) { }

      result.push({
        label: option.ANSWER_OPTION_DESCRIPTION,
        value: {
          idAnswerOption: option.ID_ANSWER_OPTION,
          dsAnswerOption: option.ANSWER_OPTION_DESCRIPTION,
          behavior,
        }
      });
    });
    return result;
  }

  const findElementToUndo = () => {
    let answers, result;

    if (nameArray === 'claimsDocuments') {
      answers = options.claims;
    } else {
      answers = options.support;
    }

    const foundItem = answers.find(answer => answer.ID_ANSWER_OPTION === oldValue);

    if (foundItem) {
      let behavior = {}
      try {
        behavior = JSON.parse(foundItem.ANSWER_BEHAVIOR)
      } catch (e) { }

      result = {
        label: foundItem?.ANSWER_OPTION_DESCRIPTION,
        value: {
          idAnswerOption: foundItem?.ID_ANSWER_OPTION,
          dsAnswerOption: foundItem?.ANSWER_OPTION_DESCRIPTION,
          behavior,
        }
      };
      setTestOld(result);
      localStorage.setItem('oldState', JSON.stringify(result));
    } else {
      setTestOld(oldValue);
      localStorage.setItem('oldState', String(oldValue));
    }
  }

  useEffect(() => {
    findElementToUndo();
  }, [oldValue]);

  const jsonToQueryString = (json) => {
    const keys = Object.keys(json).filter(key => json[key]);

    return keys
      .map((key, index) => {
        const sufix = index + 1 === keys.length
          ? ''
          : '&'

        return encodeURIComponent(key) + '=' + encodeURIComponent(json[key]) + sufix;
      }
      ).join('');
  }


  const updateDocumentType = (idDocument, documentType) => {
    loading.start();
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestUpdateDocumentType(idOperation, idDocument, documentType)
      .then(response => response.json())
      .then(res => {
        if (res.ret_code !== 200) {
          loading.stop();
          mc.error(res.ret_msg_details);
          return;
        }
        loading.stop();
        setOldValue(res.ret_value.oldIsTypeDocument);
        const filterQueryString = `?${jsonToQueryString({ search: '', idOperation })}`;

        listDocuments(filterQueryString, null, () => mc.successWithAction(() => updateDocumentType(newIdDocument, JSON.parse(localStorage.getItem('oldState')))));
        setChangeDocumentType(false);
      }).catch((error) => {
        loading.stop();
        mc.error(`There was an error while fetching your data: ${updateDocumentType.name}\n` + error);
        console.error('fitPostDocument - Error:', error);
      });
  };

  const updateDocumentName = (idDocument, documentName) => {
    if (!documentName?.trim()?.length) return setCurrentDocument({});

    loading.start();
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestUpdateDocumentName(idOperation, idDocument, documentName)
      .then(response => response.json())
      .then(res => {
        if (res.ret_code !== 200) {
          loading.stop();
          mc.error(res.ret_msg_details);
          return;
        }
        loading.stop();
        setOldValue(res.ret_value.originalFileName);
        const filterQueryString = `?${jsonToQueryString({ search: '', idOperation })}`;

        listDocuments(filterQueryString, null, () => mc.successWithAction(() => updateDocumentName(idDocument, localStorage.getItem('oldState')), 'File renamed successfully!'));
        setCurrentDocument({});
      }).catch((error) => {
        loading.stop();
        mc.error(`There was an error while fetching your data: ${updateDocumentName.name}\n` + error);
        console.error('fitPostDocument - Error:', error);
      });
  };

  const newFileExtension = document.documentName.split('.').pop();
  const file = newFileExtension.length > 5 ? 'pdf' : newFileExtension;

  let fileExtension = document.documentTypeExtension || document.nameDocumentExtension || file;

  return (
    <>
      <Formik initialValues={{ documentType: '' }}>
        {({ setFieldValue }) => (
          <FieldArray
            name="listDetail"
            render={() =>
              <span style={{ width: '100%' }}>
                <Row style={{ justifyContent: 'space-between' }}>
                  <Col md={columns[0].col} className="pl-0">
                    <InlineLabel>
                      {columns[0].title}
                    </InlineLabel>
                    <Label textColor={Colors.GRAY[0]} wordBreak>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                      {!history && expired ? null : (
                        <Checkbox
                          checked={(selectedDocs?.find((item) => item.idDocument === document.idDocument) ? true : false) || selectAllDocs}
                          onChange={() => handleSelectDocument([document])}
                        />)
                      }
                        <div style={{ width: '25px', minWidth: '25px', maxWidth: '25px' }}>
                          <FileIcon extension={fileExtension} {...defaultStyles[fileExtension]} />
                        </div>
                        {!currentDocument?.documentName ? (
                          <>
                            <span style={{ marginLeft: '8px' }}>{document.documentName}</span>
                            {(nameArray === 'supportDocuments' || nameArray === 'internalDocuments' || nameArray === 'communicationDocuments')
                              && <FontAwesomeIcon
                                style={{ cursor: 'pointer', marginLeft: '5px' }}
                                icon={faPen}
                                size="1x"
                                color="#53565a"
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  setCurrentDocument(document);
                                  setFieldValue('documentName', currentDocument?.documentName)
                                }}
                              />}
                          </>
                        ) :
                          (<Field
                            topReduce
                            name="documentName"
                            type="text"
                            style={{ marginLeft: 10, width: '100%' }}
                            value={currentDocument?.documentName}
                            onChange={documentName => setCurrentDocument({ ...currentDocument, documentName })}
                            onPressEnter={(documentName) => updateDocumentName(currentDocument?.idDocument, documentName)}
                            onBlur={(documentName) => updateDocumentName(currentDocument?.idDocument, documentName)}
                            component={InputField}
                            validation={false}
                          />)
                        }
                      </div>
                    </Label>
                  </Col>
                  <Col md={columns[1].col} className="pl-0">
                    <InlineLabel>
                      {columns[1].title}
                    </InlineLabel>
                    <Label textColor={Colors.GRAY[0]}>
                      {document.version}
                    </Label>
                  </Col>
                  <Col md={columns[2].col} className="pl-0">
                    <InlineLabel>
                      {columns[2].title}
                    </InlineLabel>
                    {!changeDocumentType ? (
                      <Label textColor={Colors.GRAY[0]}>
                        {document.documentType}
                        {(nameArray === 'claimsDocuments' || nameArray === 'supportDocuments' ||
                          nameArray === 'internalDocuments' || nameArray === 'communicationDocuments')
                          && <FontAwesomeIcon
                            style={{ cursor: 'pointer', marginLeft: '5px' }}
                            icon={faPen}
                            size="1x"
                            color="#53565a"
                            onClick={() => { setChangeDocumentType(true); setNewIdDocument(document.idDocument) }}
                          />}
                      </Label>
                    ) :
                      (<Field
                        topReduce
                        name="documentType"
                        options={fieldRenderOptions() || []}
                        searchList={fieldRenderOptions() || []}
                        onChange={event => updateDocumentType(document.idDocument, event)}
                        component={ComboBox}
                      />)
                    }
                  </Col>
                  <Col md={columns[3].col} className="pl-0">
                    <InlineLabel>
                      {columns[3].title}
                    </InlineLabel>
                    <Label textColor={Colors.GRAY[0]}>
                      {document.uploadedBy}
                    </Label>
                  </Col>
                  <Col md={columns[4].col} className="pl-0">
                    <InlineLabel>
                      {columns[4].title}
                    </InlineLabel>
                    <Label textColor={Colors.GRAY[0]}>
                      {document.uploadedDate.replaceAll('-', '/')}
                    </Label>
                  </Col>
                  <Col md={columns[5].col} className="pl-0" style={{ display: "flex"}}>
                    <TooltipCard>
                      <TooltipText>
                        <Icon
                          onClick={() => window.open(document.url, '_blank')}
                          name="search"
                          style={icon}
                        />
                      </TooltipText>
                      <TooltipBox>
                        {iconTooltips[595]}
                      </TooltipBox>
                    </TooltipCard>
                    <TooltipCard>
                      <TooltipText>
                        {(document?.idDomain && document?.idDomain !== 272 && history && document.version !== "V001") ? <Icon
                          onClick={() => onHistoryClick(document)}
                          name="history"
                          style={icon}
                        /> : null}
                      </TooltipText>
                      <TooltipBox>
                        {iconTooltips[636]}
                      </TooltipBox>
                    </TooltipCard>
                    {history && !expired ? <>
                      {!isClient && document.documentType == 'Payment Documents' ?
                      <TooltipCard>
                        <TooltipText>
                          <Icon
                            disabled={hasDelete}
                            onClick={() => setShowDeleteConfirmation(true)}
                            name="trash"
                            style={hasDelete ? opacity : null}
                          />
                        </TooltipText>
                        <TooltipBox>
                          {iconTooltips[596]}
                        </TooltipBox>
                      </TooltipCard>
                      : !isClient ?
                        <TooltipCard>
                          <TooltipText>
                            <Icon
                              disabled={!hasDelete}
                              onClick={() => hasDelete && setShowDeleteConfirmation(true)}
                              name="trash"
                              style={!hasDelete ? opacity : null}
                            />
                          </TooltipText>
                          <TooltipBox>
                            {iconTooltips[596]}
                          </TooltipBox>
                        </TooltipCard> :
                        renderFlowClient()}
                        </> : null }
                  </Col>
                </Row>
                <Row>
                  <Col className="pl-2 pr-2">
                    <Line />
                  </Col>
                </Row>
              </span>
            }
          />
        )}
      </Formik>

      <ModalConfirmDelete
        show={showDeleteConfirmation}
        onModalClose={() => {
          setShowDeleteConfirmation(false);
        }}
        onConfirm={() => handleRmvAttach(idOperation, document.idDocument)} />
    </>

  );
};

const spaceLabel = {
  allignItens: "center",
};

const icon = {
  color: Colors.GRAY[6],
};

const opacity = {
  color: Colors.GRAY[5],
  opacity: 0.5,
  cursor: "not-allowed",
};

const opacityAllowed = {
  color: Colors.GRAY[5],
  opacity: 0.5,
};

export default ListDetail;
